import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { Form } from "../../components/form/form";

export const OtpForm: React.FC<{ onValidate: () => any }> = ({
  onValidate,
}) => {
  const { localize } = useLocalization();

  return (
    <Form
      action="/otp/verify"
      method="POST"
      actionLabel={localize("confirm")}
      onSuccess={onValidate}
      errorMap={{
        otpExpired: localize("otp:otpExpired"),
        429: localize("error:rateLimitExceeded"),
      }}
    >
      <label>
        {localize("otp")}
        <input name="otp" type="text" required />
      </label>
    </Form>
  );
};
